// extracted by mini-css-extract-plugin
export default {"content":"Instructors_content__t-n-q"};